<template>
  <div class="share">
    <div>
      <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="clickLike">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M20.3186 7.74998H15.776C15.999 7.26616 16.2333 6.6567 16.3213 6.06668C16.3848 5.64061 16.3909 5.11874 16.3397 4.62199C16.2897 4.1373 16.1773 3.59536 15.9528 3.16982C15.4775 2.26864 14.8233 1.63578 14.0361 1.48224C13.1988 1.31893 12.4779 1.74495 12.0464 2.39778C11.6856 2.94375 11.5449 3.39925 11.4167 3.81444L11.4167 3.81444L11.4125 3.82786C11.2892 4.22696 11.1679 4.61901 10.8559 5.17154C10.3427 6.08056 9.92397 6.55203 9.36125 7.0454C9.071 7.29988 8.77253 7.47246 8.5 7.5831V21.225C9.28742 21.2418 10.1289 21.2524 11 21.2524C13.3441 21.2524 15.3224 21.1759 16.627 21.1071C17.9072 21.0396 19.1311 20.3943 19.7997 19.2217C20.4316 18.1135 21.2409 16.4358 21.7288 14.4296C22.1856 12.5508 22.3761 11.0232 22.4535 9.98474C22.5487 8.70656 21.5102 7.74998 20.3186 7.74998ZM7 21.1842V7.74998H5.30231C3.75929 7.74998 2.38771 8.85084 2.21213 10.4483C2.10046 11.4642 2 12.7852 2 14.2524C2 15.839 2.11749 17.3111 2.23926 18.4118C2.40726 19.9306 3.65916 21.0399 5.15251 21.1103C5.68498 21.1355 6.30853 21.1615 7 21.1842Z"
              fill="#61666D" />
      </svg>
      <span>{{like}}</span>
    </div>
    <div>
      <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(0, 24) scale(1, -1)">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M20.3186 7.74998H15.776C15.999 7.26616 16.2333 6.6567 16.3213 6.06668C16.3848 5.64061 16.3909 5.11874 16.3397 4.62199C16.2897 4.1373 16.1773 3.59536 15.9528 3.16982C15.4775 2.26864 14.8233 1.63578 14.0361 1.48224C13.1988 1.31893 12.4779 1.74495 12.0464 2.39778C11.6856 2.94375 11.5449 3.39925 11.4167 3.81444L11.4167 3.81444L11.4125 3.82786C11.2892 4.22696 11.1679 4.61901 10.8559 5.17154C10.3427 6.08056 9.92397 6.55203 9.36125 7.0454C9.071 7.29988 8.77253 7.47246 8.5 7.5831V21.225C9.28742 21.2418 10.1289 21.2524 11 21.2524C13.3441 21.2524 15.3224 21.1759 16.627 21.1071C17.9072 21.0396 19.1311 20.3943 19.7997 19.2217C20.4316 18.1135 21.2409 16.4358 21.7288 14.4296C22.1856 12.5508 22.3761 11.0232 22.4535 9.98474C22.5487 8.70656 21.5102 7.74998 20.3186 7.74998ZM7 21.1842V7.74998H5.30231C3.75929 7.74998 2.38771 8.85084 2.21213 10.4483C2.10046 11.4642 2 12.7852 2 14.2524C2 15.839 2.11749 17.3111 2.23926 18.4118C2.40726 19.9306 3.65916 21.0399 5.15251 21.1103C5.68498 21.1355 6.30853 21.1615 7 21.1842Z"
                fill="#61666D" />
        </g>
      </svg>
      <span>不喜欢</span>
    </div>
    <div>
      <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M10.4308 2.73528C11.0728 1.4346 12.9275 1.43459 13.5694 2.73528L15.4401 6.52581C15.6222 6.89474 15.9742 7.15045 16.3813 7.20961L20.5644 7.81745C21.9998 8.02603 22.573 9.78998 21.5343 10.8024L18.5074 13.7529C18.2128 14.0401 18.0783 14.4539 18.1479 14.8594L18.8624 19.0256C19.1076 20.4551 17.6071 21.5453 16.3233 20.8704L12.5818 18.9034C12.2176 18.7119 11.7826 18.7119 11.4184 18.9034L7.67696 20.8704C6.39311 21.5453 4.8926 20.4551 5.1378 19.0256L5.85236 14.8594C5.9219 14.4539 5.78747 14.0401 5.49286 13.7529L2.46594 10.8024C1.42728 9.78998 2.00042 8.02603 3.43581 7.81745L7.61892 7.20961C8.02605 7.15045 8.37801 6.89474 8.56009 6.52581L10.4308 2.73528Z"
              fill="#61666D" />
      </svg>
      <span>{{start}}</span>
    </div>
    <div>
      <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M10.2501 3.82755C10.2501 2.56388 11.717 1.86648 12.6971 2.66421L21.2708 9.64291C22.1311 10.3432 22.1311 11.6571 21.2707 12.3574L12.697 19.3359C11.717 20.1336 10.2501 19.4362 10.2501 18.1725V14.8741C9.41924 14.8822 8.48658 15.0436 7.53951 15.5019C6.3273 16.0885 5.03711 17.1875 3.894 19.1906C3.60421 19.6983 3.05095 19.8274 2.62968 19.7183C2.20029 19.6072 1.76347 19.2051 1.80276 18.5888C2.08602 14.1452 3.48809 11.3207 5.3144 9.56316C6.89392 8.0431 8.72554 7.38399 10.2501 7.11663V3.82755Z"
              fill="#61666D" />
      </svg>
      <span>{{share}}</span>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
export default {
  name: "SharePage",
  props:["like", "start", "share", "vid"],
  methods:{
    async clickLike(){
      try {
        const res = await this.$v_http.post('addLike', qs.stringify({
          vid: this.vid
        }), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}});
        console.log(res)
        if (res.data?.code === 0) {
          console.log("---success-")
        }
      } catch (error) {
        console.error('Error fetching video info:', error);
      } finally {

        console.log('------')
      }
    },

  },
}
</script>

<style scoped lang="scss">
.share{
  margin: 5vw auto;
  width: 80vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #5b5b5b;
  font-size: 7vw;
  div{
    display: flex;
    flex-direction: column;
    align-items: center;
    span{
      font-size: 3.2vw;
    }
  }
}
</style>
